let _session = {};
const _observableKeys = {};
const _emptyObject = {};

class ISessionObservable {

    constructor(context) {

        this._context = context;

    }

    from(key) {

        if (!_session[key]) {

            _session[key] = _emptyObject;

        }

        const value = _observableKeys[key] ||
        (_observableKeys[key] = new Rx.Subject(_session[key]));

        return value;

    }

}

/**
* @ngdoc service
* @name oe.enums.SessionKeys
*
* @description
* Values used for Session keys.
* @example
* 1. SessionKeys.ReferralCode
* 2. SessionKeys.PlaySoundTimer
* 3. SessionKeys.LockDeviceTimer
* 4. SessionKeys.UnlockDeviceTimer
* 5. SessionKeys.WipeData
* 6. SessionKeys.DeviceId
* 7. SessionKeys.SubscriptionDeployAppId
*/

const SessionKeys = {
    ReferralCode: 'referralCode',
    PlaySoundTimer: 'playSoundTimer',
    LockDeviceTimer: 'lockDeviceTimer',
    UnlockDeviceTimer: 'unlockDeviceTimer',
    WipeDataTimer: 'wipeDataTimer',
    DeviceId: 'deviceId',
    SubscriptionDeployAppId: 'subscriptionDeployAppId',
    SsoExtraUrlParams: 'ssoExtraUrlParams',
    ThirdPartyLogin: 'thirdPartyLogin',
    ExtraUrlParams: 'extraUrlParams',
};

/**
 * @ngdoc service
 * @name oe.core.Session
 *
 * @description
 * This class is used to save objects related to the session of application.
 */
class SessionCls {

    /**
     * @ngdoc function
     * @name oe.core.Session#Observable
     * @methodOf oe.core.Session
     * @function
     *
     * @description
     * This function can be used to get an observable session object.
     * @returns {Object} An observable session object.
     */
    Observable() {

        const observable = this._observable || (this._observable = new ISessionObservable(this));
        return observable;

    }

    /**
    * @ngdoc function
    * @name oe.core.Session#setValue
    * @methodOf oe.core.Session
    * @function
    *
    * @description
    * This function can be used to set a value for a specific key in session object.
    * @param {String} key A string used to identify the value in session object

      (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).

    * @param {*} value Value for specified key in session object.
    */
    setValue(key, value) {

        _session[key] = value;

        if (_observableKeys[key]) {

            _observableKeys[key].onNext(value);

        }

    }

    /**
    * @ngdoc function
    * @name oe.core.Session#getValue
    * @methodOf oe.core.Session
    * @function
    *
    * @description
    * This function can be used to get the value for a
    * specific key in session object.
    * @param {String} key A string used to identify the value in session object

      (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).

    * @returns {*} Value for specified key in session object
    */
    getValue(key) {

        return _session[key];

    }

    /**
    * @ngdoc function
    * @name oe.core.Session#hasValue
    * @methodOf oe.core.Session
    * @function
    *
    * @description
    * This function can be used to check if was assigned a value for specified key
    * @param {String} key A string used to identify the value in session object

      (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).

    * @returns {Boolean} True if session[key] has assigned a value.
    */
    hasValue(key) {

        return (_session[key] && _session[key] !== _emptyObject);

    }

    /**
    * @ngdoc function
    * @name oe.core.Session#clear
    * @methodOf oe.core.Session
    * @function
    *
    * @description
    * This function can be used to unassigned value of a specific key.
    * @param {String} key A string used to identify the value in session object

      (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).

    */
    clear(key) {

        _session[key] = _emptyObject;

    }

    /**
   * @ngdoc function
   * @name oe.core.Session#clearAll
   * @methodOf oe.core.Session
   * @function
   *
   * @description
   * This function can be used to unassigned all values from session object.
   */
    clearAll() {

        _session = {};

    }

}

const Session = new SessionCls();

export {
    SessionKeys,
    Session,
};



// WEBPACK FOOTER //
// ./scripts/common/services/-RFC.session.js